export default "__VITE_ASSET__C1o8azhx__"